window.Products.Clothing.Leggings = function() {
};
window.Products.Clothing.Leggings.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.Leggings.id = 12;
window.Products.Clothing.Leggings.slug = 'leggings';
window.Products.Clothing.Leggings.has_3d = true;
window.Products.Clothing.Leggings.dpi = 150;

window.Products.Clothing.Leggings.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = 0;
};

window.Products.Clothing.Leggings.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.1;
	controls.maxDistance = 3.7;
};

window.Products.Clothing.Leggings.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
	modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};